export type TaskStatus = "completed" | "uncompleted";

export type Task = {
  title: string;
  description?: string;
  systemName: string;
  reward: number;
  status: TaskStatus;
  dependsOn: string[];
  completedAt?: number;
};
export type CompletedTask = {
  title: string;
  description?: string;
  systemName: string;
  reward: number;
  status: "completed";
  dependsOn: string[];
  completedAt: number;
};

export const allTasks: Task[] = [
  {
    title: "Generate your keys",
    systemName: "generate-private-key",
    reward: 50,
    status: "uncompleted",
    dependsOn: [],
  },
  import.meta.env.VITE_CHAIN_ID !== "613419" && {
    title: "Generate KYC Certificate",
    systemName: "generate-gip1-cert",
    reward: 200,
    status: "uncompleted",
    dependsOn: ["generate-private-key"],
  },
  {
    title: "Generate X.com Certificate",
    systemName: "generate-gip3-cert",
    reward: 200,
    status: "uncompleted",
    dependsOn: ["generate-private-key"],
  },
  {
    title: "Generate Blum Certificate",
    systemName: "generate-gip2-cert",
    reward: 200,
    status: "uncompleted",
    dependsOn: ["generate-private-key"],
  },
].filter((task): task is Task => Boolean(task));
